<template>
  <v-dialog
    :value="true"
    max-width="400"
    persistent
  >
    <v-card>
      <v-toolbar color="light-blue accent-2 white--text">
        <v-toolbar-title class="px-2">
          Выберите дату
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <date-picker
              v-model="dateFrom"
              label="От"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <date-picker
              v-model="dateTo"
              label="До"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          outlined
          color="light-blue accent-3"
          @click="onChangeDate"
        >
          Выбрать
        </v-btn>
        <v-btn
          outlined
          @click="onCancel"
        >
          Отменить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import DatePicker from "@/views/loyalty/shared/components/date-picker/DatePicker.vue"

export default {
  components: { DatePicker },
  props: ["label"],
  data: () => ({
    dateFrom: null,
  dateTo: null
}),
  // watch: {
  //   dateFrom () {
  //     this.$emit("changeDateFrom", this.dateFrom)
  //   },
  //   dateTo () {
  //     this.$emit("changeDateTo", this.dateTo)
  //   }
  // },
beforeMount () {
    this.dateFrom = new Date().toISOString()
  this.dateTo = new Date().toISOString()
  // console.log('DialogToFromDate dateTo', this.dateTo)
},
  methods: {
    onCancel () {
      this.$emit('cancel')
    },
  onChangeDate () {
    this.$emit('changeDate', { dateFrom: this.dateFrom, dateTo: this.dateTo })
   }
  }
}
</script>
<style scoped>

</style>
